import { Context, createContext } from 'react';
import { ICustomProperties } from '@microsoft/applicationinsights-web';
import { ReactPlugin as ReactPluginOriginal } from '@microsoft/applicationinsights-react-js';
import { UserModel } from '@/types';

export enum TrackEventName {
  AI_PAGE = 'stylusAi',
  AI_CHAT = 'aiChat',
  NOVA = 'nova',
  PAGE = 'page',
  REPORT = 'report',
  SEARCH_PAGE = 'searchPage',
  GLOBAL_DATA_INTEGRATION = 'globalDataIntegration',
  STAT_BANK = 'statBank',
}

export enum TrackEventKey {
  EMPTY = '',
  AT_A_GLANCE = 'AAG',
  KEY_STAT = 'KS',
  TAB = 'tab',
  RELATED_REPORT = 'relatedReport',
  EDITORS_PICK = 'editorsPick',
  PERSONALISED_REPORT = 'personalisedReport',
  REPORTS_GRID = 'reportsGrid',
  STAT = 'stat',
  STAT_REPORT = 'statReport',
  SEARCH_REPORT = 'searchReport',
  SEARCH_STAT_BANK = 'searchStatBank',
  GALLERY = 'mediaGallery',
  PDF = 'pdf',
  COLOUR_CHIP = 'colourChip',
  COLOUR_PALETTE = 'colourPalette',
  IMAGE = 'image',
  BROWSE_BY = 'browseBy',
  AUDIO_PLAY_BACK = 'audioPlayBack',
  QUESTION = 'question',
  REFERENCE = 'reference',
  BANNER = 'banner',
  SUMMARY = 'summary',
  POWERPOINT = 'PP',
  KEYNOTE = 'KN',
  LOOK_AHEAD = 'lookAhead',
}

export enum TrackEventType {
  OPEN = 'Open',
  CLOSE = 'Close',
  CLICK = 'Click',
  SELECTED = 'Selected',
  DOWNLOAD = 'Download',
  ASKED = 'Asked',
  SAVE_TO_SCRAPBOOK = 'SaveToScrapbook',
  NONE = '',
}

export class ReactPlugin extends ReactPluginOriginal {
  public trackCustomEvent(
    eventName: TrackEventName,
    eventKey: TrackEventKey,
    eventType: TrackEventType,
    user: UserModel,
    properties?: ICustomProperties,
  ) {
    let propertiesWithUser = {
      ...properties,
    };
    if (user) {
      propertiesWithUser = {
        ...propertiesWithUser,
        aadId: user.userId,
        email: user.email,
        userName: user.name,
        account: user.account,
        salesForceId: user.salesforceId,
        salesForceAccountId: user.salesForceAccountId,
        ...(user.roles ? { subscriptionLevel: user.roles.join(',') } : {}),
      };
    }

    super.trackEvent({
      name: `${eventName}-${eventKey}${eventType}`,
      properties: propertiesWithUser,
    });
  }

  public trackGalleryEvent(eventType: TrackEventType, user: UserModel, properties?: ICustomProperties) {
    const props: ICustomProperties = {
      ...properties,
    };

    this.trackCustomEvent(TrackEventName.REPORT, TrackEventKey.GALLERY, eventType, user, props);
  }
}

export declare type AppInsightsReactContext = Context<ReactPlugin>;
export const AppInsightsContext = createContext<ReactPlugin>(new ReactPlugin());
